import React, { useEffect, useState } from "react";
import { Button, Modal, Tab } from "react-bootstrap";
import MyModal from "../Common/MyModal";
import LocationIcon from "../../assets/icons/library_puzzle.svg2";
import Nav from "react-bootstrap/Nav";
import CreateSolutionForm from "./CreateSolutionForm";
import SelectSolutionProject from "./SelectSolutionProject";
import MyIcon from "../Common/MyIcon";
import EditIcon from "../../assets/icons/Icon_Library/application icons/general/edit.svg2";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import {
  useGetSolutionByUuidQuery,
  useLazyGetSolutionByUuidQuery,
} from "../store/slices/settingsSlice";
import HelpButton from "../HelpContent/HelpButton";

export default function CreateSolutionModal({ editedSolution }) {
  const [tabs, setTabs] = useState([
    {
      name: "details",
      heading: editedSolution
        ? "Edit Workflow Solution"
        : "Create a Workflow Solution",
      subheading: <span></span>,
      icon: LocationIcon,
      helpKey: editedSolution ? "edit-solution-details" : "create-solution-details",
    },
    {
      name: "components",
      heading: "Select Solution Components",
      subheading: <span></span>,
      icon: LocationIcon,
      helpKey: "select-solution-components",
    },
  ]);

  const availableTabs = tabs;
  const [selectedTab, setSelectedTab] = useState(availableTabs[0]);
  const [solution, setSolution] = useState({
    Label: "",
    Description: "",
    Reference: "",
    Status: "draft",
    Version: "",
    Kind: "standard",
    Monitor: "none",
  });

  const [getSolution] = useLazyGetSolutionByUuidQuery();

  return (
    <MyModal
      size="xl"
      label={
        editedSolution ? (
          <div className="d-flex align-items-center">
            {" "}
            <MyIcon Icon={EditIcon} width={20} className="rounded-3" />
            <span className="ms-2 fw-bold text-navy">Edit Solution</span>
          </div>
        ) : (
          "Create New Solution"
        )
      }
      heading={editedSolution ? <span>Edit Solution<HelpButton helpKey="edit-solution" /></span> : <span>Create New Solution<HelpButton helpKey="create-solution" /></span>}
      buttonClassName={editedSolution ? "" : " btn-colored p-2 mb-3 fw-bold"}
      onShow={async () => {
        if (editedSolution?.Uuid) {
          const res = await getSolution({ uuid: editedSolution.Uuid });
          if ("data" in res) {
            setSolution(res.data);
          }
        } else {
          setSolution({
            Label: "",
            Description: "",
            Reference: "",
            Status: "draft",
            Version: "",
            Kind: "standard",
            Monitor: "none",
          });
          setSelectedTab(availableTabs[0]);
        }
      }}
    >
      <Modal.Body className="">
        <Tab.Container
          id="solutions-tabs"
          activeKey={selectedTab?.name}
          onSelect={(tab) =>
            setSelectedTab(availableTabs.find((t) => t.name === tab))
          }
          mountOnEnter
        >
          <Nav variant="tabs" className="flex-nowrap align-items-end">
            <div className=" w-50 d-flex me-5 align-items-center">
              <div className="fs-2 fw-bold text-capitalize">
                {selectedTab?.heading}<HelpButton helpKey={selectedTab?.helpKey} />
              </div>
            </div>
            <div className="flex-grow-1" />
            {solution.Uuid &&
              availableTabs.map((t, i) => {
                const isSelected = selectedTab?.name === t.name;
                return (
                  <Nav.Item>
                    <Nav.Link eventKey={t.name}>
                      <div
                        className="text-black fw-bold  mt-2 text-uppercase"
                        style={{ letterSpacing: 2 }}
                      >
                        {t.name}
                      </div>
                    </Nav.Link>
                  </Nav.Item>
                );
              })}
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="details">
              <div className="my-1">
                <CreateSolutionForm
                  solution={solution}
                  setSolution={setSolution}
                />
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="components">
              <div className=" my-1">
                <SelectSolutionProject solution={solution} />
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
        <div className="d-flex justify-content-end">
          <div>
            {availableTabs.indexOf(selectedTab) > 0 && (
              <Button
                type="submit"
                className="btn btn-colored-reverse rounded-pill fw-bold px-4 my-2"
                onClick={() =>
                  setSelectedTab(
                    availableTabs[availableTabs.indexOf(selectedTab) - 1]
                  )
                }
              >
                PREVIOUS
              </Button>
            )}
          </div>
          <div className="">
            {solution.Uuid &&
              availableTabs.indexOf(selectedTab) + 1 !==
                availableTabs.length && (
                <Button
                  type="submit"
                  className="btn btn-colored-reverse rounded-pill fw-bold px-4 my-2"
                  onClick={() => {
                    setSelectedTab(
                      availableTabs[
                        availableTabs.indexOf(
                          availableTabs.find((t) => t.name === selectedTab.name)
                        ) + 1
                      ]
                    );
                  }}
                >
                  NEXT
                </Button>
              )}
          </div>
        </div>
        <JsonCollapse json={solution} label="Solution data" />
      </Modal.Body>
    </MyModal>
  );
}
